import React, { useEffect } from 'react';
import LogRocket from 'logrocket';

const LogrocketWrapper = ({ user }) => {
  useEffect(() => {
    if (!window.LogRocketInitialized) {
      LogRocket.init('sgko6z/tyb');
      window.LogRocketInitialized = true;
    }
    
    if (user) {
      if (user.accountType === 'child_account') {
        // COPPA: children get an opaque id only — never name/email to a 3rd party.
        LogRocket.identify(user.id);
      } else {
        // Adults (parents, teachers, PollyStop) are the customers — identify them so
        // we can see who signed up, where they bounce, and follow up by email.
        LogRocket.identify(user.id, {
          name: user.fullname,
          email: user.email,
        });
      }
    }
  }, [user]);

  return null;
};

export default LogrocketWrapper;
